import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import * as StateManager from '../../store/state/state-manager';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import { REMOVE_CONTAINER_ITEM, REPLACE_CONTAINER_ITEM } from '../../store/state/actions';
import { getCurrentCaseViewMode, isErrorActionType, promiseHandler } from '../common-helper';
import type { Action } from '../../store/state/state-manager';
import { getParentContainerItem } from '../../container/container-utils';
import constants from '../../constants';

import { executeReleaseLockRequest } from './async-request';

export const releaseLock = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];

  return action$.pipe(
    ofType(REMOVE_CONTAINER_ITEM, REPLACE_CONTAINER_ITEM),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((actionInPayload: Action['payload']) => {
      const {
        containerItemID,
        caseID,
        context,
        caseDeleted,
        skipReleaseLockRequest,
        currentCaseViewMode,
        isProcessAction,
        isInCreateStage,
        deleteWork
      } = actionInPayload;
      // Check if either the previous or current case view mode is 'perform'
      const isInPerformMode = currentCaseViewMode === constants.PERFORM_MODE;

      // Determine if the case is not in 'perform' mode based on given conditions
      const isCaseInPerformMode = caseID && isInPerformMode;

      if (deleteWork) {
        return of([]);
      }

      if (isProcessAction && isInCreateStage) {
        return executeReleaseLockRequest(actionInPayload);
      }

      // For deleted cases don't trigger release lock. Request will fail as resource is not available.
      if (containerItemID === context && !caseDeleted && !skipReleaseLockRequest && isCaseInPerformMode) {
        return executeReleaseLockRequest(actionInPayload);
      }
      if (
        containerItemID?.includes(constants.MODAL) &&
        getCurrentCaseViewMode(getParentContainerItem(containerItemID) as string) === constants.REVIEW_MODE
      ) {
        return executeReleaseLockRequest(actionInPayload);
      }
      return of([]);
    }),
    mergeMap((chainedData) => {
      if (chainedData && isErrorActionType(chainedData.type)) {
        actionsOut.push(processDataToDispatchErrorAction(chainedData));
      }
      return actionsOut;
    }),
    map(() => {
      StateManager.dispatch(actionsOut);
      promiseHandler(actionsOut, actionMgrID);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export default releaseLock;
